var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "menu_svg__a",
    d: "M5.971 21.276c-1.74 0-1.74-2.61 0-2.61H22.03c1.74 0 1.74 2.61 0 2.61H5.97zm0-5.833c-1.74 0-1.74-2.61 0-2.61H22.03c1.74 0 1.74 2.61 0 2.61H5.97zm0-5.834c-1.74 0-1.74-2.609 0-2.609H22.03c1.74 0 1.74 2.61 0 2.61H5.97z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v28H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "menu_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#menu_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#50555C",
    fillRule: "nonzero",
    xlinkHref: "#menu_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#868686",
    mask: "url(#menu_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v28H0z"
  }))))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHBhdGggaWQ9ImEiIGQ9Ik01Ljk3MSAyMS4yNzZjLTEuNzQgMC0xLjc0LTIuNjEgMC0yLjYxSDIyLjAzYzEuNzQgMCAxLjc0IDIuNjEgMCAyLjYxSDUuOTd6bTAtNS44MzNjLTEuNzQgMC0xLjc0LTIuNjEgMC0yLjYxSDIyLjAzYzEuNzQgMCAxLjc0IDIuNjEgMCAyLjYxSDUuOTd6bTAtNS44MzRjLTEuNzQgMC0xLjc0LTIuNjA5IDAtMi42MDlIMjIuMDNjMS43NCAwIDEuNzQgMi42MSAwIDIuNjFINS45N3oiLz48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMCAwaDMydjMySDB6Ii8+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAyKSI+PHBhdGggZD0iTTAgMGgyOHYyOEgweiIvPjxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjx1c2UgZmlsbD0iIzUwNTU1QyIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjYSIvPjxnIGZpbGw9IiM4Njg2ODYiIG1hc2s9InVybCgjYikiPjxwYXRoIGQ9Ik0wIDBoMjh2MjhIMHoiLz48L2c+PC9nPjwvZz48L3N2Zz4=";
export { SvgMenu as ReactComponent };